module.exports = "<Label class=\"form-control-label\" >{{label}}</Label>\r\n"